import React from "react";
import "./App.css";
import Content from "./Content";

function App() {
  return (
    <div className="App">
      <Content />
    </div>
  );
}

export default App;